'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Component = require('../../Component');

var _Component2 = _interopRequireDefault(_Component);

var _main = require('../templates/main');

var _main2 = _interopRequireDefault(_main);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _INumber = require('../../../common/iObjects/INumber');

var _INumber2 = _interopRequireDefault(_INumber);

var _documentOffset = require('document-offset');

var _documentOffset2 = _interopRequireDefault(_documentOffset);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;

if (!nativeInputValueSetter) {
    nativeInputValueSetter = function nativeInputValueSetter(value) {
        this.value = value;
    };
}

var Main = function (_View) {
    _inherits(Main, _View);

    function Main() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Main);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Main.__proto__ || Object.getPrototypeOf(Main)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Main, [{
        key: 'computeStyleHash',
        value: function computeStyleHash() {
            return _get(Main.prototype.__proto__ || Object.getPrototypeOf(Main.prototype), 'computeStyleHash', this).call(this) + this.state.focused;
        }
    }, {
        key: '_updateProgress',
        value: function _updateProgress() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var elOffset = (0, _documentOffset2.default)(this.progress),
                _props = this.props,
                roundingAccuracy = _props.roundingAccuracy,
                end = _props.end,
                start = _props.start,
                step = _props.step,
                progress = void 0,
                value = void 0;


            if (elOffset) {
                progress = (e.pageX - elOffset.left) / this.progress.offsetWidth * 100;

                progress = progress < 1 ? 0 : progress;
                progress = progress > 99 ? 100 : progress;

                value = (end - start) * (progress / 100) + start;

                if (!isNaN(step) && step > 0) {
                    value = Math.round(value / step) * step;
                }

                return this.value = value.toFixed(roundingAccuracy);
            } else {
                return Promise.resolve();
            }
        }
    }, {
        key: '_getProgress',
        value: function _getProgress() {
            var number = new _INumber2.default(this.value),
                float = number.toFloat(),
                _props2 = this.props,
                end = _props2.end,
                start = _props2.start;


            if (number.validate()) {
                if (float > end) {
                    float = end;
                } else if (float < start) {
                    float = start;
                }
            } else {
                float = start;
            }

            return (float - start) / (end - start) * 100;
        }
    }, {
        key: 'value',
        get: function get() {
            return this.props.value;
        },
        set: function set(value) {
            nativeInputValueSetter.call(this.nativeElement, String(value) || '');
            this.nativeElement.dispatchEvent(new Event('input', { bubbles: true }));
        }
    }]);

    return Main;
}(_Component2.default);

Main.propTypes = {
    onChange: _propTypes2.default.func,
    onDrag: _propTypes2.default.func,
    start: _propTypes2.default.number,
    step: _propTypes2.default.number,
    end: _propTypes2.default.number,
    roundingAccuracy: _propTypes2.default.number,
    hint: _propTypes2.default.bool
};
Main.defaultProps = {
    // onChange handler
    onChange: null,
    onDrag: null,
    start: 0,
    step: 0,
    end: 100,
    roundingAccuracy: 3
};
Main.displayName = 'Interval';

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.template = _main2.default;
    this.state = {
        focused: false
    };

    this._handleDragEnd = function () {
        _this2.setState({ focused: false });
        return _this2;
    };

    this._handleDragStart = function () {
        _this2.setState({ focused: true });
        return _this2;
    };

    this._handleProgressClick = function (event) {
        _this2._updateProgress(event);

        return _this2;
    };

    this._handleMouseMove = function (event) {
        if (_this2.state.focused) {
            _this2._updateProgress(event);
        }

        return _this2;
    };

    this._handleChange = function () {
        if (typeof _this2.props.onChange === 'function') {
            var _props3;

            (_props3 = _this2.props).onChange.apply(_props3, arguments);
        }

        return _this2;
    };

    this._progressRef = function (el) {
        return _this2.progress = el;
    };

    this._nativeRef = function (el) {
        if (typeof _this2.props.elementRef === 'function') {
            _this2.props.elementRef(_this2);
        }

        _this2.nativeElement = el;
    };
};

exports.default = Main;